import { useSelector } from 'react-redux';
import { RootState } from 'state/reducers';

export default function useSelect<Selected extends unknown>(
    selector: (state: RootState) => Selected
): Selected {
    return useSelector<RootState, Selected>(selector);
}
